import { HttpService } from '@/shared/services'
import GetPayrollReceiptsDto from './interfaces/GetReceiptsInputDto'
import Receipt from '../models/Receipt'
import List from '@/shared/dtos/List'
import GenerateReceiptInputDto from './interfaces/GenerateReceiptInputDto'

const http = new HttpService()

export const getReceipts = async (dto: GetPayrollReceiptsDto) => {
  const response = await http.get<List<Receipt[]>>(
    `/receipts/${dto.employeeId}?startDate=${dto.startDate}&endDate=${dto.endDate}&process=${dto.process}`
  )

  if (!response.data) {
    return null
  }

  return response.data
}

export const generateReceipt = async (dto: GenerateReceiptInputDto) => {
  const response = await http.post<any, any>(
    `/receipts/generate?employeeId=${dto.employeeId}&closedId=${dto.closedId}`,
    {},
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        Accept: 'application/pdf',
      },
    }
  )

  if (!response.data) {
    return null
  }

  return response.data
}
